<template>
  <div
    id="day"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <div class="mb-2 mt-2 pt-3">
      <button-search
        ref="buttonSearch"
        placeholder="搜索日期"
        @search="searchEvent"
        :showGj="true"
      >
        <!-- 左边 -->
        <template #left>
          <div>
            <span class="mr-3"
              >总新增：<el-tag type="success">
                {{ total_list.total_add }}
              </el-tag></span
            >
            <span class="mr-3"
              >总活跃：<el-tag type="success">
                {{ total_list.total_num }}
              </el-tag></span
            >
            <!-- <span class="mr-3"
              >总在线时长：<el-tag type="success">
                {{ total_list.total_online_time }}(秒)
              </el-tag></span
            > -->

            <span class="mr-4"
              >当前查看域名：<el-tag>{{ check_url }} </el-tag></span
            >

            <span>快捷查看： </span>
            <el-button
              class="mr-2"
              @click="faskSearch('all')"
              type="primary"
              size="mini"
              v-auth="'add' + auth_val"
              >全部</el-button
            >
            <el-button
              class="mr-2"
              @click="faskSearch('android')"
              type="primary"
              size="mini"
              v-auth="'add' + auth_val"
              >安卓</el-button
            >
            <el-button
              class="mr-2"
              @click="faskSearch('ios')"
              type="primary"
              size="mini"
              v-auth="'add' + auth_val"
              >苹果</el-button
            >

            <el-button
              class="mr-2"
              @click="faskSearch('pc')"
              type="primary"
              size="mini"
              v-auth="'add' + auth_val"
              >PC</el-button
            >
            <el-button
              class="mr-2"
              @click="faskSearch('h5')"
              type="primary"
              size="mini"
              v-auth="'add' + auth_val"
              >H5</el-button
            >

            <el-button
              class="mr-2"
              @click="faskSearch('majia')"
              type="primary"
              size="mini"
              v-auth="'add' + auth_val"
              >马甲</el-button
            >
            <!-- <el-button class="mr-2" @click="checkExcelData()" type="primary" size="mini">
							<i class="el-icon-download mr-1"></i>导出excel</el-button> -->
          </div>

          <!-- <el-button v-show="type==2" class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">新增房间</el-button> -->
          <!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button> -->
        </template>

        <!-- 高级搜索 -->
        <template #from>
          <el-form inline ref="form" :model="from" label-width="100px">
            <el-form-item label="日期" size="small" class="mb-0">
              <el-date-picker
                v-model="from.time"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="mb-0">
              <el-button type="info" @click="searchEvent" size="small"
                >搜索
              </el-button>
              <el-button size="small" @click="clearSearch"
                >清空筛选条件</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </button-search>
    </div>

    <!-- 表格 -->
    <div class="mt-3 pt-2">
      <el-table
        height="750"
        @sort-change="sortChange"
        :default-sort="{ prop: prop, order: sort }"
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column fixed type="selection" width="45" align="center">

				</el-table-column> -->
        <el-table-column
          fixed
          align="center"
          type="index"
          label="排序"
          width="50"
        >
        </el-table-column>

        <el-table-column
          align="center"
          fixed
          width="120"
          prop="date"
          label="日期"
        >
        </el-table-column>

        <el-table-column align="center" prop="mt_cz_money" label="新增">
          <template slot-scope="v">
            <span class="font-weight-bolder text-danger">{{
              v.row.add_num
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="mt_cz_money" label="活跃">
          <template slot-scope="v">
            <span class="font-weight-bolder text-danger">{{ v.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="mt_cz_money" label="在线时长(秒)">
          <template slot-scope="v">
            <span class="font-weight-bolder text-danger">{{
              v.row.today_time
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="mt_cz_money"
          label="进入直播间总人数"
        >
          <template slot-scope="v">
            <span class="font-weight-bolder text-danger">{{
              v.row.today_join
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="mt_cz_money"
          label="今日最高在线峰值"
        >
          <template slot-scope="v">
            <span class="font-weight-bolder text-danger">{{
              v.row.today_max
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="height: 60px"></div>
    <el-footer
      class="d-flex border-top bg-white align-items-center px-0 position-fixed"
      style="bottom: 0; left: 200px; right: 0; z-index: 100"
    >
      <!-- 底部 -->

      <div style="flex: 1" class="px-2">
        <el-pagination
          :current-page="page.current"
          :page-sizes="page.sizes"
          :page-size="page.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        >
        </el-pagination>
      </div>
    </el-footer>

    <!-- 麦位信息 -->
    <el-dialog title="麦位信息" :visible.sync="wheatModel" top="5vh">
      <!-- 表单内容 -->

      <div class="px-3 mb-3">
        <el-row :gutter="20">
          <el-col
            :span="index <= 1 ? 12 : 6"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="grid-content bg-purple text-center mb-3">
              <div>
                <el-avatar
                  v-if="item.user_id > 0"
                  :size="60"
                  :src="item.head"
                ></el-avatar>
                <span
                  v-else
                  class="btn btn-light border mb-1"
                  style="
                    width: 61px;
                    height: 61px;
                    line-height: 61px;
                    border-radius: 100%;
                  "
                >
                  <i class="el-icon-plus" style="font-size: 30px"></i>
                </span>
              </div>
              <div>
                <small>{{ item.name ? item.name : "空位" }}</small>
              </div>
              <div>
                <small class="text-warning">{{ item.wheat_name }}</small>
                <i
                  v-if="item.is_wheat == 0"
                  class="el-icon-turn-off-microphone"
                ></i>
                <i v-if="item.is_lock == 0" class="el-icon-lock"></i>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="wheatModel = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { export2Excel } from "@/common/js/util.js";

import common from "@/common/mixins/common.js";
import buttonSearch from "@/components/common/button-search.vue";
export default {
  components: {
    buttonSearch,
  },
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      type: "1",
      wheat_list: [],
      wheatModel: false,
      createModel: false,
      editIndex: -1,
      //搜索数据
      from: {
        user_id: "",
        out_trade_no: "",
        type: 0,
        pay_type: 0,
        is_error: -1,
        is_win: -1,
        time: [],
        check_type: "all",
      },
      prop: "date",
      sort: "descending",
      model_title: "官方房间",
      auth_val: "Pay",
      preUrl: "data/dayList", //列表地址
      delAllUrl: "data/delPayAll", //批量删除地址
      delUrl: "data/delPay", //删除单条地址
      addUrl: "data/addPay", //添加/修改地址
      editStatusUrl: "data/editPay", //修改状态地址

      tableData: [],
      form: {
        headUrl: "",
        headId: 0,
      },
      page: {
        current: 1,
        sizes: [31, 62, 100, 200],
        size: 31,
        total: 0,
      },
      options: [],
      rules: {},
      rule_list: [],
      check_img_list: [],
      list: [],
      loading: false,
      class_list: [],
      total_list: [],
      total_money: 0,

      excel_list: [],
      check_url: "",
    };
  },
  watch: {
    activeName(e) {
      console.log(e);
    },
  },
  created() {
    //this.commonList();
  },
  methods: {
    faskSearch(url) {
      this.from.check_type = url;
      this.searchEvent();
    },
    // getListResult(e) {
    // 	console.log(e,"----");
    // 	this.check_url = e.check_url
    // },
    exportData() {
      let title = "充值统计";
      if (this.from.time[0]) {
        title =
          "充值统计-(" + this.from.time[0] + " 至 " + this.from.time[1] + ")";
      }
      export2Excel(this.columns, this.excel_list, title);
    },
    //获取列表
    checkExcelData() {
      this.layout.loading = true;
      this.api
        .post("/data/paydataExcel", {
          search: this.search,
          prop: this.prop,
          type: this.type,
          sort: this.sort == "ascending" ? "asc" : "desc",
        })
        .then((res) => {
          let all = res.data;
          let list = all.data.list;

          this.excel_list = list.list;
          //console.log(list.list)
          this.layout.loading = false;
          this.exportData();
        })
        .catch((err) => {
          // 失败
          console.log(err);
          this.layout.loading = false;
        });
    },
    handleClick(tab, event) {
      this.search = "";
      this.getList();
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.api
          .post("/user/searchUser", {
            search: query,
          })
          .then((res) => {
            let all = res.data;
            let list = all.data.list;
            this.options = list;

            this.loading = false;
          })
          .catch((err) => {
            // 失败
            this.loading = false;
          });
      } else {
        this.options = [];
      }
    },
    //提交
    submit() {
      this.$refs.form.validate((res) => {
        if (res) {
          //this.form.default = this.form.default.replace(/\n/g,',')
          this.form.id = this.editIndex;
          this.addOrEdit(this.form);
          // 关闭模态框
        }
      });
    },

    // 打开模态框
    openModel(e = false) {
      // 增加
      if (!e) {
        // 初始化表单
        this.form = {
          headUrl: "",
          headId: 0,
          bgUrl: "",
          bgId: 0,
          name: "",
          room_id: "",
          user_id: "",
          status: 1,
          is_home: 1,
          is_show: 1,
          classify: 1,
          notice: "",
          room_type: this.type,
          aUrl: "",
          aId: 0,
        };
        this.editIndex = -1;
      } else {
        // 修改
        this.form = {
          headUrl: e.row.cover,
          headId: 0,
          bgUrl: e.row.bg,
          bgId: 0,
          name: e.row.name,
          classify: e.row.classify,
          room_id: e.row.room_id,
          user_id: e.row.user_id,
          status: e.row.status,
          is_home: e.row.is_home,
          is_show: e.row.is_show,
          notice: e.row.notice,
          room_type: this.type,
          aUrl: e.row.attribute,
          aId: 0,
        };

        this.editIndex = e.row.id;
      }
      // 打开dialog
      this.createModel = true;
    },
    openWheatModel(obj) {
      this.anchorList(obj.id);
    },
    //公共列表
    commonList() {
      this.api
        .post("/room/classTypeList", {})
        .then((res) => {
          let all = res.data;
          let list = all.data.list;

          this.type_list = list.type_list;
          this.class_list = list.class_list;
        })
        .catch((err) => {
          // 失败
        });
    },
    anchorList(room_id) {
      this.wheatModel = true;
      this.layout.loading = true;
      this.api
        .post("/room/anchorList", {
          room_id: room_id,
        })
        .then((res) => {
          let all = res.data;
          let list = all.data.list;

          console.log(list);

          for (let i = 0; i < list.length; i++) {
            if (list[i].user) {
              list[i].head = list[i].user.head;
              list[i].name = list[i].user.name;
              list[i].yl_id = list[i].user.yl_id;
            }
            if (list[i].num == -1) list[i].wheat_name = "陪伴位";
            if (list[i].num == 0) list[i].wheat_name = "主持位";
            if (list[i].num == 1) list[i].wheat_name = "一号麦";
            if (list[i].num == 2) list[i].wheat_name = "二号麦";
            if (list[i].num == 3) list[i].wheat_name = "三号麦";
            if (list[i].num == 4) list[i].wheat_name = "四号麦";
            if (list[i].num == 5) list[i].wheat_name = "五号麦";
            if (list[i].num == 6) list[i].wheat_name = "六号麦";
            if (list[i].num == 7) list[i].wheat_name = "七号麦";
            if (list[i].num == 8) list[i].wheat_name = "八号麦";
          }
          this.list = list;

          this.layout.loading = false;
        })
        .catch((err) => {
          // 失败
          this.layout.loading = false;
        });
    },
    //前往修改页面
    editItem(obj) {
      this.$router.push({
        name: "set_manager_rule",
        query: {
          item: obj,
        },
      });
    },
    getListResult(e) {
      console.log(e, "----");
      this.check_url = e.check_type;
      this.tableData = e.list;
      this.total_list = e.total_list;

      this.total_money = e.total_money;
      this.check_img_list = e.list.map((item) => {
        return item.bg;
      });

      this.options = [];
      if (e.user_list) {
        this.options = e.user_list.map((item) => {
          return {
            id: item.id,
            yl_id: item.yl_id,
            name: item.name,
            head: item.head,
            phone: item.phone,
          };
        });
        console.log(this.options);
      }
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        user_id: "",
        out_trade_no: "",
        type: 0,
        pay_type: 0,
        is_error: -1,
        is_win: -1,
        time: [],
      };

      this.$refs.buttonSearch.closeSuperSearch();
      this.search = "";
      this.getList();
    },
  },
};
</script>

<style></style>
